import { TriangleMark } from "./Weave";

const PHRASES = [
  "Founder first. Business second.",
  "You don't have to build alone.",
  "Business support with soul.",
  "Helping founders thrive, not just survive.",
  "Innovation through connection.",
  "Practical support for ambitious people.",
];

function Row({ ariaHidden = false }) {
  return (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {PHRASES.map((p, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 text-3xl font-extrabold tracking-tight sm:text-4xl ${
              i % 2 === 1 ? "text-outline" : "text-ink"
            }`}
          >
            {p}
          </span>
          <TriangleMark className="h-6 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="motto-marquee" className="overflow-hidden border-y border-ink/10 py-7">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
